import { inject } from '@angular/core';
import { CanMatchFn, Routes } from '@angular/router';
import { ModeService } from './core/mode/mode.service';

const isPlatform: CanMatchFn = () => inject(ModeService).isPlatform();
const isTenant: CanMatchFn = () => inject(ModeService).isTenant();

export const routes: Routes = [
  {
    path: 'public/tatami/:token',
    loadComponent: () =>
      import('./public/pages/public-tatami-display.page').then(
        (m) => m.PublicTatamiDisplayPageComponent,
      ),
  },
  {
    path: '',
    canMatch: [isPlatform],
    loadChildren: () =>
      import('./platform/platform.routes').then((m) => m.platformRoutes),
  },
  {
    path: '',
    canMatch: [isTenant],
    loadChildren: () => import('./tenant/tenant.routes').then((m) => m.tenantRoutes),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/unknown-host.component').then((m) => m.UnknownHostComponent),
  },
];
